import getIn from '../utils/getIn'
import hasOwnDeepProperty from "../utils/deepLookup";
import isInApp from './isInApp'

async function awaitGTM(eventName){
    return new Promise((resolve) => {
        gtmDataObject.push({
            event: eventName,
            eventCallback: resolve
        })
    })
}

let dataLayer = {}

let platform
let isResponsive
let technology
let breadcrumbUID
let padl
let page
let app

async function init() {
    await awaitGTM('optimize.callback');
    setDataLayer()
}

if (!hasOwnDeepProperty(window, 'config.padl.namespace')) {
    init()
} else {
    setDataLayer()
}

function setDataLayer () {
    padl = window[window.config.padl.namespace].dataLayer
    page = padl.page.page.pageInfo
    app = padl.app.app
    platform = (app.landscape === 'NC2-mosaic' || app.landscape === 'NC2-classic') ? 'desktop' : 'mobile'
    isResponsive = getIn('config.responsiveModeEnabled', window)
    breadcrumbUID = page.breadcrumbUID
    technology = breadcrumbUID.split(':')[4] || 'originalline'
    if (technology === 'originalline') {
        technology = 'original'
    } else if (technology === 'vertuoline') {
        technology = 'vertuo'
    }
    dataLayer = {
        channel: page.segmentBusiness,
        platform,
        country: app.market,
        language: page.language,
        isInApp,
        isProd: app.isEnvironmentProd,
        currency: app.currency,
        breadcrumbUID,
        technology,
        pageName: page.pageName,
        isMosaic: app.landscape === 'NC2-mosaic' && !isResponsive,
        isResponsive,
        isMobile: platform === 'mobile',
        isClassic: app.landscape === 'NC2-classic'
    }
}

export default dataLayer



// WEBPACK FOOTER //
// ./node_modules/nespresso-library/src/core/dataLayer.js